import { Controller } from '@hotwired/stimulus'

export default class SubmissionDeletedDialogController extends Controller<HTMLDialogElement> {
  connect(): void {
    this.#verifyAndShowModal()
  }

  #verifyAndShowModal() {
    if (!document.querySelector('.submission-drawer .submission-delete-btn')) {
      this.element.showModal()
    }
  }

  refresh() {
    location.reload()
  }
}
